export default "__VITE_ASSET__3$3bnw8n__"